import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { adminMail } from '../../../../../Apiservices/Api';

const CommentsModalpop = ({ 
  show, 
  onHide, 
  selectedLead, 
  baseURL 
}) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [isAddingComment, setIsAddingComment] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [managerid, setManagerId] = useState(null);
  const [assignedSalesId, setAssignedSalesId] = useState(null);

  // Reset state when modal closes
  useEffect(() => {
    if (!show) {
      setComments([]);
      setNewComment("");
      setIsAddingComment(false);
      setManagerId(null);
      setAssignedSalesId(null);
    }
  }, [show]);

  // Fetch comments when modal opens
  useEffect(() => {
    if (selectedLead && show) {
      setManagerId(selectedLead.managerid);
      setAssignedSalesId(selectedLead.assignedSalesId);
      fetchComments(selectedLead.leadid);
    }
  }, [selectedLead, show]);

  const fetchComments = async (leadid) => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${baseURL}/comments/${leadid}`);
      // Sort comments in DESCENDING order (newest first)
      const sortedComments = response.data.sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
      );
      setComments(sortedComments);
    } catch (error) {
      console.error("Error fetching comments:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddComment = async () => {
    if (!newComment.trim()) return;
    
    setIsAddingComment(true);
    const trimmedComment = newComment.trim();
    
    const commentName = "Admin";

    const comment = {
      name: commentName,
      leadid: selectedLead.leadid,
      timestamp: new Date().toISOString(),
      text: trimmedComment,
      notificationmessage: `${commentName}:${trimmedComment}`,
      managerId: managerid,
      userId: assignedSalesId,
      email: `${adminMail}`
    };

    try {
      const commenturl = `${baseURL}/comments/add`;
      const response = await fetch(commenturl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(comment),
      });

      if (response.ok) {
        const addedComment = await response.json();
        // Add new comment at the beginning (since we want descending order)
        setComments(prevComments => [addedComment, ...prevComments]);
        setNewComment("");
      } else {
        console.error("Failed to add comment");
      }
    } catch (error) {
      console.error("Error adding comment:", error);
    } finally {
      setIsAddingComment(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Comments for {selectedLead?.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="comment-form-container">
          <div className="mb-3">
            <Form.Group>
              <Form.Label>Add a New Comment</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Write your comment here..."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
              />
              <Button
                className="mt-2"
                style={{ backgroundColor: "#ff9966", borderColor: "#ff9966" }}
                onClick={handleAddComment}
                disabled={!newComment.trim() || isAddingComment}
              >
                {isAddingComment ? 'Adding...' : 'Add Comment'}
              </Button>
            </Form.Group>
          </div>

          {/* Comments section with fixed height and scroll */}
          <div style={{ 
            height: "200px",
            overflowY: "auto",
            border: "1px solid #ddd", 
            padding: "10px", 
            borderRadius: "5px" 
          }}>
            {isLoading ? (
              <p className="text-center text-muted">Loading comments...</p>
            ) : comments.length === 0 ? (
              <p className="text-center text-muted">No comments yet</p>
            ) : (
              comments.map((comment, index) => (
                <div key={comment.id || index} className="mb-3">
                  <p style={{ fontSize: "12px", color: "gray", marginBottom: "2px" }}>
                    {new Date(comment.timestamp).toLocaleString("en-IN", {
                      timeZone: "Asia/Kolkata",
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    })}
                  </p>
                  <p style={{ marginBottom: "5px" }}>
                    <strong>{comment.name}</strong>:  
                    <span style={{ whiteSpace: "pre-line", marginLeft: "5px" }}>{comment.text}</span>
                  </p>
                  <hr style={{ margin: "5px 0" }} />
                </div>
              ))
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CommentsModalpop;